
import Unlimited from "../../../assets/outline/Unlimited.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UnlimitedIcon({ className, dataTestid = "UnlimitedIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Unlimited data-testid={dataTestid} className={classes} {...rest} />
  );
}
